import { snackbarActions } from "../config/action-config";

const initial = { show: false, severity: '', message: "" };

const snackbarReducer = (state = initial, action) => {
  const { type, severity, message } = action;
  switch (type) {
    case snackbarActions.SHOW: return { show: true, severity, message };
    case snackbarActions.HIDE: return { ...state, show: false, message: '' };
    default: return state;
  }
};

export default snackbarReducer;
